export enum UserAgent {
  IOS_SPAIN_CASINO_HYBRID = '5eaaadc3-3145-4490-a4d8-db9bdf9d4182',
  IOS_UK_VEGAS_HYBRID = 'c99a9785-8a16-4801-9474-02b5a8fbb58e',
}

export const isHybrid888 = () =>
  /*
    In some iOS wrapper environments, the global `navigator` object 
    may not always be available or defined. This check ensures the code 
    does not throw an error in such cases and gracefully handles 
    environments where `navigator` is missing.
  */
  typeof navigator !== 'undefined' &&
  (navigator.userAgent.includes(UserAgent.IOS_UK_VEGAS_HYBRID) ||
    navigator.userAgent.includes(UserAgent.IOS_SPAIN_CASINO_HYBRID));
